import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { LaboratorioService } from 'src/app/services/laboratorio/laboratorio.service';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-proveedores-derivados',
  templateUrl: './proveedores-derivados.component.html',
  styleUrls: ['./proveedores-derivados.component.scss'],
  standalone: false
})
export class ProveedoresDerivadosComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  isDtInitialized = false;

  public idLaboratorio = 0;
  public nombreLab = '';

  public ofertas: any[] = [];
  public cargando = false;
  public guardando = false;

  public nuevoCodigo = '';
  public nuevoExamen = '';
  public nuevoValor: string | number = '';

  public idExamenEditar = 0;
  public editarCodigo = '';
  public editarExamen = '';
  public editarValor: string | number = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private laboratorioService: LaboratorioService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      order: [[0, 'asc']],
      language: LanguageApp.spanish_datatables
    };

    this.idLaboratorio = Number(this.route.snapshot.paramMap.get('idLaboratorio') || 0);
    this.nombreLab = this.route.snapshot.queryParamMap.get('nombreLab') || 'Laboratorio';
    if (!this.idLaboratorio) {
      this.router.navigateByUrl('/sistema/laboratorios');
      return;
    }

    this.obtenerOfertas();
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  get token(): string {
    return localStorage.getItem('token') || '';
  }

  obtenerOfertas() {
    this.cargando = true;
    this.laboratorioService.listarOfertas(this.token, this.idLaboratorio).subscribe({
      next: (resp: any) => {
        this.ofertas = Array.isArray(resp?.rows) ? resp.rows : [];
        if (!this.isDtInitialized) {
          this.dtTrigger.next(null);
          this.isDtInitialized = true;
        } else {
          this.rerender();
        }
        this.cargando = false;
      },
      error: () => {
        this.ofertas = [];
        this.cargando = false;
      }
    });
  }

  private rerender(): void {
    if (!this.dtElement) return;
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  abrirAgregar(modal: any) {
    this.nuevoCodigo = '';
    this.nuevoExamen = '';
    this.nuevoValor = '';
    this.modalService.open(modal, { centered: true });
  }

  abrirEditar(modal: any, oferta: any) {
    this.idExamenEditar = Number(oferta.COD_EXAM);
    this.editarCodigo = String(oferta.CODN_EXAM || '');
    this.editarExamen = String(oferta.NOM_EXAM || '');
    this.editarValor = String(Number(oferta.AMOUNT_EXAM || 0).toFixed(2));
    this.modalService.open(modal, { centered: true });
  }

  guardarExamen() {
    const codigo = String(this.nuevoCodigo || '').trim();
    const nombre = String(this.nuevoExamen || '').trim();
    const valorRaw = String(this.nuevoValor ?? '').trim();
    const valor = Number(valorRaw);

    if (!codigo || !nombre || !valorRaw || !Number.isFinite(valor)) return;

    this.guardando = true;
    this.laboratorioService.crearOferta(this.token, {
      idLaboratorio: this.idLaboratorio,
      codigo,
      nombre,
      valor
    }).subscribe({
      next: () => {
        this.guardando = false;
        this.toastr.success('Examen agregado correctamente');
        this.modalService.dismissAll();
        this.obtenerOfertas();
      },
      error: () => {
        this.guardando = false;
        this.toastr.error('No se pudo guardar');
      }
    });
  }

  actualizarExamen() {
    const codigo = String(this.editarCodigo || '').trim();
    const nombre = String(this.editarExamen || '').trim();
    const valorRaw = String(this.editarValor ?? '').trim();
    const valor = Number(valorRaw);

    if (!this.idExamenEditar || !codigo || !nombre || !valorRaw || !Number.isFinite(valor)) return;

    this.guardando = true;
    this.laboratorioService.editarOferta(this.token, this.idExamenEditar, {
      codigo,
      nombre,
      valor
    }).subscribe({
      next: () => {
        this.guardando = false;
        this.toastr.success('Examen actualizado correctamente');
        this.modalService.dismissAll();
        this.obtenerOfertas();
      },
      error: () => {
        this.guardando = false;
        this.toastr.error('No se pudo actualizar');
      }
    });
  }

  eliminarExamen(oferta: any) {
    const idExamen = Number(oferta.COD_EXAM);
    if (!idExamen) return;

    Swal.fire({
      title: '¿Está seguro de borrar el exámen?',
      text: '¡Si no lo está puede cancelar la acción!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, borrar exámen!',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (!result.isConfirmed) return;

      this.laboratorioService.eliminarOferta(this.token, idExamen).subscribe({
        next: () => {
          this.toastr.success('Eliminado correctamente');
          this.obtenerOfertas();
        },
        error: () => {
          this.toastr.error('No se pudo eliminar');
        }
      });
    });
  }

  volver() {
    this.router.navigateByUrl('/sistema/laboratorios');
  }
}

export class LanguageApp {
  public static spanish_datatables = {
    processing: 'Procesando...',
    search: 'Buscar:',
    lengthMenu: 'Mostrar _MENU_ registros',
    info: 'Mostrando desde _START_ al _END_ de _TOTAL_ elementos',
    infoEmpty: 'Mostrando ningún elemento.',
    infoFiltered: '(filtrado _MAX_ elementos total)',
    infoPostFix: '',
    loadingRecords: 'Cargando registros...',
    zeroRecords: 'No se encontraron registros',
    emptyTable: 'No hay datos disponibles en la tabla',
    paginate: {
      first: 'Primero',
      previous: 'Ant',
      next: 'Sig',
      last: 'Último'
    },
    aria: {
      sortAscending: ': Activar para ordenar la tabla en orden ascendente',
      sortDescending: ': Activar para ordenar la tabla en orden descendente'
    }
  };
}
